import { ChangeDetectionStrategy, Component, signal, ViewEncapsulation } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { IDataSource } from '@se/cp.common';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { isFunction } from 'lodash-es';
import { AutocompleteCellEditorPopupComponent } from './autocomplete-cell-editor-popup/autocomplete-cell-editor-popup.component';

export interface IAutocompleteCellEditorParams {
    required?: boolean;
    inlineEditor?: boolean;
    dataSource?: IDataSource | string[] | (() => IDataSource | string[]);
}
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-autocomplete-cell-editor',
    templateUrl: './autocomplete-cell-editor.component.html',
    styleUrls: ['./autocomplete-cell-editor.component.scss'],
    imports: [AutocompleteCellEditorPopupComponent, ReactiveFormsModule],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutocompleteCellEditorComponent implements ICellEditorAngularComp {
    readonly items = signal<string[] | IDataSource>([]);
    readonly cellReady = signal<boolean>(false);
    readonly formControl = new FormControl<string | null>(null);

    agInit(params: ICellEditorParams & IAutocompleteCellEditorParams): void {
        if (params.required) this.formControl.addValidators(Validators.required);
        const dataSource = isFunction(params.dataSource) ? params.dataSource() : (params.dataSource ?? []);
        this.items.set(dataSource);
        this.formControl.setValue(params.value ?? null, { emitEvent: false });
        this.formControl.updateValueAndValidity({ emitEvent: false });
    }

    getValue(): string | null {
        return this.formControl.valid ? this.formControl.getRawValue() : null;
    }

    isCancelBeforeStart(): boolean {
        return false;
    }

    isPopup(): boolean {
        return true;
    }

    afterGuiAttached(): void {
        this.cellReady.set(true);
    }
}
